var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.75V5C7 3.89543 7.89543 3 9 3H11C12.1046 3 13 3.89543 13 5V5.75H15.5C15.9142 5.75 16.25 6.08579 16.25 6.5C16.25 6.91421 15.9142 7.25 15.5 7.25H15V15C15 16.1046 14.1046 17 13 17H7C5.89543 17 5 16.1046 5 15V7.25H4.5C4.08579 7.25 3.75 6.91421 3.75 6.5C3.75 6.08579 4.08579 5.75 4.5 5.75H7ZM8.5 5.5H11.5V5C11.5 4.72386 11.2761 4.5 11 4.5H9C8.72386 4.5 8.5 4.72386 8.5 5V5.5ZM6.5 7.25H13.5V15C13.5 15.2761 13.2761 15.5 13 15.5H7C6.72386 15.5 6.5 15.2761 6.5 15V7.25Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.a378bf24b7a74d11ffa7f9da9c278d49.svg";
export { ForwardRef as ReactComponent };